import { requestFromApi } from './request-from-api';
export const fetchProgramData = async (options) => {
    try {
        const programsResponse = await requestFromApi(options, {
            url: 'programs',
            method: 'GET'
        });
        return programsResponse;
    }
    catch (err) {
        return Promise.reject(err);
    }
};
